"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.favorite.add': 'Aggiungi ai preferiti',
    'conversations.favorite.remove': 'Rimuovi dai preferiti',
};
